// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import Sort from './Sort'

// Function based component which renders the sort menu
function SortMenu({ sorters, setSorters, defaultObj }) {
  // Add sort item to the menu
  const addSort = () => setSorters(sorters.concat(defaultObj))

  // Generic function to update the sort object
  // This is used by the other functions here
  const updateSorter = (id, func) => {
    const newSorters = sorters.map((obj, oid) => {
      if (oid === id) {
        return func(obj)
      }
      return obj
    })
    setSorters(newSorters)
  }

  // Deletes specified sort item from the menu
  const deleteSort = (id) => {
    let newSorters = [...sorters]
    newSorters.splice(id, 1)
    setSorters(newSorters)
  }

  // Updates the selected item of the specified sort item
  const updateSortSelected = (id, newSelected) => {
    updateSorter(id, (obj) => {
      return { ...obj, selected: newSelected }
    })
  }

  // Updates the sorting order of the specified sort item
  const updateSortOrder = (id, newOrder) => {
    updateSorter(id, (obj) => {
      return { ...obj, order: newOrder }
    })
  }

  return (
    <div className="med-sort-menu">
      <h1 className="med-table-menu-header">Sort</h1>
      <p style={{ textAlign: 'center', marginBottom: '15px', color: 'var(--med-additional-text)' }}>
        Sort your data by selecting up to 4 columns. The sorting will be applied in order, 
        meaning the first column will be sorted first, then within those results, 
        the second column will be sorted, and so on.
      </p>
      <hr className="med-top-separator" />
      <div className="med-table-menu-sort-container">
        {
          /* Render a Sort component for each sorter in the current state
            Every sorter component will receive all the functions as props to update the state */
          sorters.map((obj, oid) => (
            <Sort
              key={uuidv4()}
              id={oid}
              item={obj}
              del={deleteSort}
              sel={updateSortSelected}
              order={updateSortOrder}
            />
          ))
        }
        {
          /* Only render an add sort option if there are at most 3 sorters */
          sorters.length < 4 && (
            <div
            className="med-table-menu-add-filter med-primary-text"
            onClick={addSort}
            role={'button'}
            tabIndex={'0'}
            onKeyPress={(e) => {
              if (e.key === 'Enter') addSort()
            }}
          >
            Add Sorting
            <i className="bx bxs-plus-square med-table-menu-add-filter-icon"></i>
          </div>
          )
        }
      </div>
    </div>
  )
}

export default SortMenu